import React from "react";
import { Link } from "react-router-dom";
import "./navbar.scss";
import { ScalableImage } from "design_system/src";

export const ImmersiveNavbar: React.FC = () => {
    return (
        <div
            className="pos_fixed display_block"
            style={{ zIndex: 999, width: "100%" }}
        >
            <header className="navbar shadow_medium ">
                <div className="main-container">
                    <div
                        className="display_flex"
                        style={{ justifyContent: "start", alignItems: "center" }}
                    >
                        <Link to="/" className="custom_a">
                            <figure className="m_none display_flex">
                                <ScalableImage
                                    src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon"
                                    alt="Logo Ozon"
                                    className="h_xl"
                                    desktopWidth={5}
                                    mobileWidth={5}
                                />
                            </figure>
                        </Link>
                    </div>
                </div>
            </header>
        </div>
    );
};
